import { CategoryLandingLink } from '@/types/CategoryLink';
import { isEqual, uniqWith } from 'es-toolkit';
import { ItemFacet, ItemFacets } from '@/types/ItemFacets';

export const generateDiscoverLinks = (
    facets: ItemFacets,
    createCategoryLandingLink: (mainItem: ItemFacet, secondItem?: ItemFacet) => CategoryLandingLink
): CategoryLandingLink[] => {
    const discoverItems: CategoryLandingLink[] = [];
    let shouldCreateMat = true;
    let shouldCreateCreator = true;
    if (facets && facets.categories && facets.categories.length > 0 && facets.creators) {
        facets.creators.some((creator, index) => {
            discoverItems.push(createCategoryLandingLink(facets.categories[0], creator));
            return index === 1;
        });

        shouldCreateCreator = false;
    }

    if (facets && facets.creators && facets.creators.length > 0 && shouldCreateCreator) {
        discoverItems.push(createCategoryLandingLink(facets.creators[0]));
    }

    if (facets && facets.materialsTechniques && facets.categories && facets.categories.length > 0) {
        facets.materialsTechniques.some((materialsTechniques, index) => {
            discoverItems.push(createCategoryLandingLink(facets.categories[0], materialsTechniques));
            return index === 1;
        });

        shouldCreateMat = false;
    }

    if (facets && facets.materialsTechniques && facets.materialsTechniques.length > 0 && shouldCreateMat) {
        discoverItems.push(createCategoryLandingLink(facets.materialsTechniques[0]));
    }
    if (facets && facets.categories && facets.categories.length > 0) {
        discoverItems.push(createCategoryLandingLink(facets.categories[0]));
    }
    if (facets && facets.stylePeriods && facets.stylePeriods.length > 0) {
        discoverItems.push(createCategoryLandingLink(facets.stylePeriods[0]));
    }
    if (facets && facets.origins && facets.origins.length > 0) {
        discoverItems.push(createCategoryLandingLink(facets.origins[0]));
    }

    return uniqWith(discoverItems, isEqual);
};
